import {Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ConfirmationService, LazyLoadEvent, MessageService} from "primeng/api";
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {ImportExportComponent} from "@app/_components/_helpers/import-export/import-export.component";
import {OrderDetailService} from "@app/_components/reservation/components/reservation/order-detail/order-detail.service";
import {ReservationService} from "@app/_components/reservation";
import {AlertService} from "@app/_services";
import {Router} from "@angular/router";
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {OrderDetail} from "@app/_components/reservation/components/reservation/order-detail/order-detail";
import {OrderDetailComponent} from "@app/_components/reservation/components/reservation/order-detail/order-detail/order-detail.component";
import {ReservationLedgerListComponent} from "@app/_components/reservation/components/reservation-ledger/reservation-ledger-list/reservation-ledger-list.component";
import {OrderDetailTaxListComponent} from "@app/_components/reservation/components/reservation/order-detail-tax/order-detail-tax-list/order-detail-tax-list.component";
import { first } from 'rxjs/operators';
import * as moment from "moment";
import {AddStatementDetailComponent} from "@app/_components/owner-statements/add-statement-detail/add-statement-detail.component";

@Component({
    selector: 'app-statement-detail-list',
    templateUrl: './statement-detail-list.component.html',
    styleUrls: ['./statement-detail-list.component.css'],
    providers: [MessageService, ConfirmationService],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class StatementDetailListComponent implements OnInit {
  grandTotalAmount: any;
  amountReceived: any;
  reGenerateInvoicePopUp = false;
  addTravelAgentFeePopUp = false;
  formTravelAgent: UntypedFormGroup;

  @ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;
  constructor(
    private orderDetailService: OrderDetailService,
    private reservationService: ReservationService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.statuses = orderDetailService.statuses
    this.orderDetails = [];
    if(data){
      this.reservationId = data.reservationId
      this.shortTermRentalId = data.shortTermRentalId
      this.orderId = data.orderId
      this.ruReservationId = data.ruReservationId
    }
  }



  // data
  @Input() orderDetails: any;
  @Input() showHeaders = true;
  @Input() showPagination = true;
  @Input() reservationId: any;
  @Input() checkInDate: any;
  @Input() checkOutDate: any;
  @Input() reservation: any;
  @Input() ownerStmtExp: any;
  @Input() type: any = 'Expense';
  @Input() orderId: any;
  @Input() ruReservationId: any;
  @Input() shortTermRentalId: any;
  @Input() hideServiceDate = false;
  @Input() hideName = false;
  @Input() compactHeader = false;
  @Input() fontStyle = 'normal !important';
  @Input() styleClass = 'p-datatable-striped';
  @Input() tableBackground = 'white';
  @Output() refreshOrder = new EventEmitter<any>();
  opsNoteDetails = [];

  orderDetail: OrderDetail;

  // paging
  first = 0;
  rows = 50;

  // list
  datasource: any;

  recordTotal: number;
  lazyLoadEvent: LazyLoadEvent;
  loading = true;
  multiSortMeta = [];

  // forms
  formLoading = false;

  statuses: any;

  //Show dialog for OpsNotes with Rate Details calculations
  showOpsNoteDialog: boolean = false;

  columns: any[] = [
    { field: 'name', header: 'Description',  width: 'auto' },
    { field: 'quantity', header: '#', width: 'auto' },
    { field: 'amount', header: 'Amount ', width: 'auto' },
    /*{ field: 'listPriceAdjustmentAmount', header: '$ Discount ', width: 'auto' },*/
    { field: 'subTotal', header: 'SubTotal', width: 'auto' },
    { field: 'tax', header: 'Tax', width: 'auto' },
    { field: 'total', header: 'Total', width: 'auto' },
  ];

  paidByList = {
    1: 'KBM',
    2: 'Owner',
    3: 'Vendor'
  };

  ngOnInit(): void {
    try {
      if(this.type === 'Expense') {
        this.columns.shift();
        this.columns.unshift({ field: 'paidBy', header: 'Paid By', width: 'auto' });
        if(!this.hideName) {
          this.columns.unshift({ field: 'name', header: 'Name',  width: 'auto' });
        }
        if(!this.hideServiceDate) {
          this.columns.unshift({ field: 'serviceDate', header: 'Service Date',  width: 'auto' });
        }
        
      }
      // default sort of list
      this.multiSortMeta = [];
      this.multiSortMeta.push({ field: 'orderProductVO.orderProductId', order: 1 });
      // this.findNightlyRateOpsNotesDetails();
      this.buildForm()
    }
    catch (error) {
      console.log('Error: ' + error);
    }
  }

  /**
   * Find the Ops Notes for nightly rate calculated form YieldMax Portal based on
   * CheckInDate, CheckOutDate and ShortTermRentalId
   */
  findNightlyRateOpsNotesDetails()
  {
    this.opsNoteDetails = [];
    if(this.shortTermRentalId != null && this.checkInDate != null && this.checkOutDate != null)
    {
      try {
        // this.formLoading = true;
        this.showOpsNoteDialog = true;
        let startDateStr = this.addLocalTimeToDateTime(new Date(this.checkInDate));
        let endDateStr = this.addLocalTimeToDateTime(new Date(this.checkOutDate));
        let opsRequest = {
          "shortTermRentalId" : this.shortTermRentalId,
          "checkInDate" : startDateStr,
          "checkOutDate" : endDateStr
        };
        this.orderDetailService.findNightlyRateOpsNotesDetails(opsRequest)
          .subscribe(
            (res: any) => {
              console.log('findNightlyRateOpsNotesDetails SUCCESS: ' + JSON.stringify(res));
              this.opsNoteDetails.push(res.data.rateLos);
              // this.alertService.success(res, true);
              this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            },
            (err: any) => {
              this.formLoading = false;
              console.log('findNightlyRateOpsNotesDetails FAIL: ' + JSON.stringify(err));
              this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
            },
            () => { this.formLoading = false; });
      } catch (error) {
        this.formLoading = false;
        console.log('Form Invalid: ' + JSON.stringify(error));
        this.alertService.error(error);
      }
    }
  }

  /*********
   * Delete Button
   *
   */
  onRowDelete(event: any) {
    console.log('onRowDelete: ' + JSON.stringify(event));
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete Id# ' + event.orderDetailId + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.formDelete(event);
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
      }
    });
  }


  /*********
   * Lazy Load All Data
   *
   */
  loadLazy(event: LazyLoadEvent) {
    try {
      this.loading = true;
      this.lazyLoadEvent = event;

      console.log(
        ' event.first:' + event.first
        + '  |  event.rows:' + event.rows
        + '  |  event.sortField:' + event.sortField
        + '  |  event.sortOrder:' + event.sortOrder
        + '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
        + '  |  event.globalFilter:' + event.globalFilter
        + '  |  event.filters:' + JSON.stringify(event.filters)
      );

      /*
      *
      * Default Sort
      */
      // https://stackoverflow.com/questions/679915/how-do-i-orderDetail-for-an-empty-javascript-object
      // if we are NOT filtering and we are NOT sorting, apply a default sort
      if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: 'orderProductVO.orderProductId', order: 1 });
      }
      if (this.reservationId) {
        // show only orderDetails that are part of reservationId
        let reservationIdFilter = { 'reservationVO.reservationId': { 'value': this.reservationId, 'matchMode': 'in' } };
        Object.assign(event.filters, reservationIdFilter);
      }else{
        this.orderDetails = [];
        return;
      }


      const pageNumber = Math.round(event.first / event.rows);
      this.orderDetailService.findByFilter(
        pageNumber, event.rows,
        event.sortField,
        event.sortOrder,
        event.multiSortMeta,
        event.globalFilter,
        event.filters).pipe(first()).subscribe(

        (res: any) => {
          this.datasource = res.data.reviews;
          this.recordTotal = res.page.recordTotal;
          this.orderDetails = res.data.orderDetails;
          console.log(JSON.stringify(res.page));
        },
        (err: any) => {
          console.log('reviews list error!: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => { this.loading = false; }
      );

      if (this.datasource) {
        this.orderDetails = this.datasource.slice(event.first, (event.first + event.rows));
      }
    } catch (error) {
      console.log('loadLazy(' + event + ')' + error);
    }
  }

  getStatus() {
    return
  }

  /*********
   * onRowSelect()
   * Used to handle row click (to edit, link, etc)
   */
  onRowSelect(event: any) {
    console.log('onRowSelect: ' + JSON.stringify(event));
    //this.onOpenFormEdit(event.data);
  }

  // handled in rate-bucket-form
  formAddTravelAgentFee() {
    try {
      // stop here if form is invalid
      this.formTravelAgent.markAllAsTouched();
      if (this.formTravelAgent.invalid) {
        return;
      }
      console.log('property-add post: ' + JSON.stringify(this.formTravelAgent.value));
      this.formLoading = true;
      this.reservationService.addTravelAgentFee(this.formTravelAgent.value)
        .subscribe(
          (res: any) => {
            this.formLoading = false;

            console.log('property-add SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.refreshOrder.emit();
          },
          (err: any) => {
            // Do NOT reset formLoading on error — a 504 means the travel agent fee may have been added.
            // Keep button disabled to block re-submit.
            console.log('addTravelAgentFee FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error) {
      this.alertService.error(error);
    }

  }


  /*********
   * formUpdate()
   * Used for row editing
   */
  formUpdate(orderDetail: OrderDetail) {
    try {
      this.formLoading = true;
      this.orderDetailService.update(orderDetail)
        .subscribe(
          (res: any) => {
            console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
            this.orderDetails.map((orderDetail, i) => {
              if (orderDetail.orderDetailId === res.data.orderDetail.orderDetailId) {
                this.orderDetails[i] = res.data.orderDetail;
              }
            });
            // this.alertService.success(res, true);
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
          },
          (err: any) => {
            console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
            this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
          },
          () => { this.formLoading = false; });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * formDelete()
   * Used for row editing
   */
  formDelete(orderDetail: any) {
    try {
      // stop here if form is invalid
      console.log('Delete Submitted: ' + JSON.stringify(orderDetail));

      this.formLoading = true;
      this.orderDetailService.delete(orderDetail.orderDetailId)
        .subscribe(
          (res: any) => {
            console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
            this.orderDetails.splice(this.orderDetails.indexOf(orderDetail), 1);
            this.recordTotal = this.orderDetails.length;
            this.refreshOrder.emit();
            this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OrderDetail ' + orderDetail.orderDetailId + ' Deleted', life: 3000 });
          },
          (err: any) => {
            console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
            this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OrderDetail ' + orderDetail.orderDetailId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
          },
          () => { this.formLoading = false; });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * Add New Button
   *
   */
  onOpenFormAdd(obj, type) {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    // To add new orderDetails, use reservationId, orderId to link FK
    let statementDetail = {
      reservationId : this.reservationId,
      orderId : this.orderId
    }

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: (obj ? 'Edit ' : 'Add ') + type + ' Detail',
      orderDetail : statementDetail,
      shortTermRentalId : this.shortTermRentalId,
      reservation: this.reservation,
      ownerStmtExp: this.ownerStmtExp,
      type,
      objToEdit: obj
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(AddStatementDetailComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.refreshOrder.emit();

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.addOrderDetailCB(data);

        // close the dialogBox
        dialogRef.close();
      });
  }


  /*********
   * Edit Button
   *
   */
  onOpenFormEdit(orderDetail: OrderDetail) {
    // use type
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      orderDetail: orderDetail,
      shortTermRentalId :this.shortTermRentalId,
      title: 'Edit Order Detail'
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(OrderDetailComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.refreshOrder.emit();

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.updateOrderDetailCB(data);

        // close the dialogBox
        dialogRef.close();
      });

    dialogRef.componentInstance.doDelete.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.deleteOrderDetailCB(data);

        // close the dialogBox
        dialogRef.close();
      });
  }


  /**
   *
   * Dialog from Form Callbacks
   * To edit the list show add/edit/delete in real time from the popup form
   *
   */
  addOrderDetailCB(orderDetail: OrderDetail) {
    this.refreshTable();
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderDetail ' + orderDetail.orderDetailId + ' Added', life: 3000 });
  }

  updateOrderDetailCB(orderDetail: OrderDetail) {
    this.refreshTable();
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderDetail ' + orderDetail.orderDetailId + ' Updated', life: 3000 });
  }

  deleteOrderDetailCB(orderDetail: OrderDetail) {
    this.refreshTable();

    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderDetail ' + orderDetail.orderDetailId + ' Deleted', life: 3000 });
  }

  /**********
   *
   * PAGINATOR FUNCTIONS
   */
  next() { this.first = this.first + this.rows; }
  prev() { this.first = this.first - this.rows; }
  reset() { this.first = 0; }
  isLastPage(): boolean { return this.orderDetails ? this.first === (this.orderDetails.length - this.rows) : true; }
  isFirstPage(): boolean { return this.orderDetails ? this.first === 0 : true; }

  get Statuses() {
    return this.statuses;
  }

  getStatusName(orderDetail: any) {
    if (orderDetail?.status) {
      const status = this.statuses.find((e: any) => e.value == orderDetail.status);
      return status.name;
    }
    else {
      return '';
    }
  }

  reloadPage() {
    window.location.reload();
  }

  /*********
   * View Reservation Ledger
   *
   */
  viewReservationLedger() {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "80vw";
    dialogConfig.width = "75vw";
    dialogConfig.maxHeight = "40vw";
    dialogConfig.height = "95vh";

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Reservation Ledgers',
      showFilter: true,
      showPagination: false,
      displayClose: false,
      isPopup: true,
      reservationId: this.reservationId

    };
    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(ReservationLedgerListComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    // dialogRef.componentInstance.doAdd.subscribe(
    // 	data => {
    // 		console.log('Dialog output:', data);

    // 		// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
    // 		this.addOrderDetailCB(data);

    // 		// close the dialogBox
    // 		dialogRef.close();
    // 	});
  }

  total(orderDetail: any){
    return (orderDetail?.quantity * orderDetail?.listPrice);
  }

  /*grandTotal(){
    let total = 0
    this.orderDetails.forEach(orderDetail => {
      total += orderDetail?.total
    });
    return total;
  }

  totalTax(){
    let total = 0
    this.orderDetails.forEach(orderDetail => {
      total += orderDetail?.tax
    });
    return total;
  }
  totalAmount(){
    let total = 0
    this.orderDetails.forEach(orderDetail => {
      total += orderDetail?.subTotal
    });
    return total;
  }*/
  syncInvoice(){
    this.confirmationService.confirm({
      message: 'Are you sure you want to sync invoice with Streamline? for ReservationId# ' + this.reservationId,
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.reservationService.syncInvoice(this.reservationId)
          .subscribe(
            (res: any) => {
              console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
              // this.alertService.success(res, true);
              this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
              // this.refreshTable();
              this.refreshOrder.emit();
            },
            (err: any) => {
              this.refreshTable();
              this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
            },
            () => { this.formLoading = false; });
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Sync canceled.', life: 1000 });
      }
    });
  }

  syncPayment(){
    this.confirmationService.confirm({
      message: 'Are you sure you want to sync payment with Streamline? for ReservationId# ' + this.reservationId,
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.reservationService.syncPayment(this.reservationId)
          .subscribe(
            (res: any) => {
              console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
              // this.alertService.success(res, true);
              this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
              // this.refreshTable();
              this.refreshOrder.emit();
            },
            (err: any) => {
              this.refreshTable();
              this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
            },
            () => { this.formLoading = false; });
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Sync canceled.', life: 1000 });
      }
    });
  }
  viewOrderDetailTaxes() {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Reservation Ledgers',
      showFilter: false,
      showPagination: false,
      displayClose: false,
      reservationId: this.reservationId,
      orderDetails: this.orderDetails,

    };
    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(OrderDetailTaxListComponent, dialogConfig);

    //to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doDelete.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.refreshOrder.emit();

        // close the dialogBox
        dialogRef.close();
      });
  }
  // Its used to update reservation order details when, add/update or delete order products from reservation
  refreshTable(){
    //this.loadLazy(this.lazyLoadEvent);
  }

  // this is used to regenerate invoice
  openPopUpReGenerateInvoice(){
    this.amountReceived = null;
    this.reGenerateInvoicePopUp = true;
  }

  openPopUpAddTravelAgentFee(){
    this.buildForm()
    this.addTravelAgentFeePopUp = true;
  }

  /*********
   * formUpdate()
   * Used for row editing
   */
  reGenerateInvoice() {
    try {
      this.formLoading = true;
      const data = {
        amountReceived: this.amountReceived,
        reservationId: this.reservationId
      }
      this.reservationService.reGenerateInvoice(data)
        .subscribe(
          (res: any) => {
            console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
            // this.refreshTable();
            this.refreshOrder.emit();
            this.formLoading = false;
            this.reGenerateInvoicePopUp = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: "Invoice regenerate successfully" });
          },
          (err: any) => {
            // Do NOT reset formLoading on error — a 504 means the invoice regeneration may have
            // already completed. Keep button disabled to block re-submit.
            console.log('reGenerateInvoice FAIL: ' + JSON.stringify(err));
            this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
          },
          () => {  });
    } catch (error) {
      this.formLoading = false;
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  reGenerateOtaInvoice() {
    try {
      this.confirmationService.confirm({
        message: 'Are you sure you want to reGenerate Rental-United reservation invoice? for ReservationId# ' + this.reservationId,
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.formLoading = true;
          this.reservationService.reGenerateOtaInvoice(this.reservationId)
            .subscribe(
              (res: any) => {
                console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
                // this.refreshTable();
                this.refreshOrder.emit();
                this.formLoading = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: "Invoice regenerate successfully" });
              },
              (err: any) => {
                // Do NOT reset formLoading on error — a 504 means the OTA invoice regeneration may
                // have already completed. Keep button disabled to block re-submit.
                console.log('reGenerateOtaInvoice FAIL: ' + JSON.stringify(err));
                this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
              },
              () => {  });
        },
        reject: () => {
          this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Sync canceled.', life: 1000 });
        }
      });


    } catch (error) {
      this.formLoading = false;
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /**
   * Redirect to Property page on YM filtered by current dialog property
   * @param opsNoteDetail
   * @param defaultTabIndx
   */
  redirectToProperty(opsNoteDetail:any, defaultTabIndx: any)
  {
    let baseUrl = '/property-config/'+opsNoteDetail.propertyId;
    if(opsNoteDetail.rateBucketId)
    {
      baseUrl = baseUrl + '/' + opsNoteDetail.rateBucketId;
    }

    baseUrl = baseUrl + '/' + defaultTabIndx;
    //Rate Season
    if(defaultTabIndx == 4)
    {
      let checkInDate = opsNoteDetail.checkInDate;
      let checkOutDate = opsNoteDetail.checkOutDate;
      if(checkInDate == null)
      {
        checkInDate = moment.utc(this.checkInDate).format('YYYY-MM-DD');
      }

      if(checkOutDate == null)
      {
        //End date creates timezone issue hence using this method to remove timezone
        //   let searchedEndDate = this.addLocalTimeToDateTime(this.checkOutDate);
        checkOutDate = moment.utc(this.checkOutDate).format('YYYY-MM-DD');
      }
      baseUrl = baseUrl + '/' + checkInDate + '/' + checkOutDate;
    }

    const url = this.router.serializeUrl(
      this.router.createUrlTree([baseUrl])
    );
    window.open(url, '_blank');
  }

  /**
   * Add time plus local time GMT hours as http request change time to UTC time
   * @param datetime
   * @returns
   */
  addLocalTimeToDateTime(datetime) {
    return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
  }

  private buildForm() {
    this.formTravelAgent = this.formBuilder.group({
      agentName: [],
      agentPCT: [],
      privateNotes: [],
      reservationId: [this.reservationId],
    });
  }
  public exportAsExcelFile($event): void {
    let data = [];
    try {
      this.orderDetails.forEach((e) => {
        let row = {
          name: e.name,
          quantity: e.quantity,
          listPrice: e.listPrice,
          listPriceAdjustmentAmount: e.listPriceAdjustmentAmount,
          subTotal: e.subTotal,
          tax: e.tax,
          total: e.total,
        };

        data.push(row);
        e.orderDetailTaxes?.forEach((tax) => {
          let row = {
            name:  tax.name + " (" + tax?.taxPCT+")",
            quantity: '',
            listPrice: '',
            listPriceAdjustmentAmount: '',
            subTotal: '',
            tax: tax.taxAmount,
            total: '',
          };
          data.push(row);
        });
      });
    }catch (e){

    }
    this.importExportComponent.exporData($event, data, "ReservationInvoice#"+this.reservationId);
  }

  onDeleteByReservationId(){
    console.log('onRowDelete: ' + JSON.stringify(event));
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete all invoice items? ',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        try {
          this.exportAsExcelFile("pdf")
          // stop here if form is invalid
          this.formLoading = true;
          this.orderDetailService.deleteAllByReservationId(this.reservationId)
            .subscribe(
              (res: any) => {
                this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ReservationInvoice Deleted for reservation#'+this.reservationId, life: 3000 });
                this.loadLazy(this.lazyLoadEvent);
              },
              (err: any) => {
                this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Reservation#' + this.reservationId+ ' invoice could not be deleted.', life: 3000 });
              },
              () => { this.formLoading = false; });
        } catch (error) {
          console.log('Form Invalid: ' + JSON.stringify(error));
          this.alertService.error(error);
        }
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
      }
    });
  }
}
